import {call, put, takeLatest, fork, all, delay,} from 'redux-saga/effects';
import * as Types from '../constants/Types';
import * as AgentService from './../services/agentService';

import i18n from '../constants/initLng';
import * as Func from "../helpers/functions";
import {PATHS, SAGA_DELAY_TIMEOUT} from '../constants/Define';
import { parseRatingListRequestParams } from '../utils/commonUtils';
import {
    setListAgents as setListAgentsAction,
    setAgentDetail as setAgentDetailAction,
    setAgentListReports as setAgentListReportsAction
} from './../actions/agentAction';
import history from './../helpers/history';
import moment from 'moment';
import { omit } from 'lodash';

function* getAllListAgent() {
    yield takeLatest(Types.AGENT_ALL_LIST_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(AgentService.getAllAgent);
        yield put(setListAgentsAction(result));
    }, errorHandleAgent(Types.AGENT_LIST_FAIL)))
}

function* getListAgent() {
    yield takeLatest(Types.AGENT_LIST_ACTION, Func.sagaWrapper(function* (action) {
        const pageSize = action.filters.pageSize ? action.filters.pageSize > 10 ? action.filters.pageSize : undefined : undefined;
        const pageIndex = action.filters.pageIndex ? action.filters.pageIndex > 1 ? action.filters.pageIndex : undefined : undefined;
        const params = {
            ...action.filters,
            pageSize, pageIndex,
        };
        yield delay(SAGA_DELAY_TIMEOUT);
        const result = yield call(AgentService.getAgent, params);
        yield put(setListAgentsAction(result));
    }, errorHandleAgent(Types.AGENT_LIST_FAIL)))
}

function* getAgentListReports() {
    yield takeLatest(Types.AGENT_LIST_REPORTS_ACTION, Func.sagaWrapper(function* (action) {
        const params = parseListRequestParamsCameo(action.params || {});
        const data = yield call(AgentService.getAgentListReports, params);
        yield put(setAgentListReportsAction(data.result, { ...params, ...omit(data, 'result') }));
    }, errorHandleAgent(Types.AGENT_LIST_FAIL)))
}

function* getAgentDetail() {
    yield takeLatest(Types.AGENT_DETAIL_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(AgentService.getAgentDetail, action.id);
        yield put(setAgentDetailAction(result));
    }, errorHandleAgent(Types.AGENT_DETAIL_FAIL)))
}

function* updateAgentDetail() {
    yield takeLatest(Types.AGENT_DETAIL_UPDATE_ACTION, Func.sagaWrapper(function* (action) {
        Func.sagaLoadingMessage(action);
        yield call(AgentService.updateAgentDetail, action.agent.agent);
        successHandleAgent(action, action.agent.agent.name);
        yield put(setAgentDetailAction(action.agent.agent));
        history.push(PATHS.AGENT.LIST.path);
        history.go();
    }, errorHandleAgent(Types.AGENT_DETAIL_FAIL)))
}

function* createAgentDetail() {
    yield takeLatest(Types.AGENT_DETAIL_CREATE_ACTION, Func.sagaWrapper(function* (action) {
        Func.sagaLoadingMessage(action);
        const result = yield call(AgentService.createAgentDetail, action.agent);
        successHandleAgent(action, action.agent.name);
        yield put(setAgentDetailAction(result));
        history.push(PATHS.AGENT.LIST.path);
        history.go();
    }, errorHandleAgent(Types.AGENT_DETAIL_FAIL)))
}

function* deleteAgentDetail() {
    yield takeLatest(Types.AGENT_DETAIL_DELETE_ACTION, Func.sagaWrapper(function* (action) {
        Func.sagaLoadingMessage(action);
        yield call(AgentService.deleteAgentDetail, action.agent);
        Func.sagaSuccessMessage({
            action,
            message: `${i18n.t('notification.removeSuccess')}`,
        });
        const params = parseRatingListRequestParams(action.filter || {});
        const resultList = yield call(AgentService.getAgent, params);
        yield put(setListAgentsAction(resultList));
    }, errorHandleAgent(Types.AGENT_DETAIL_FAIL)));
}

function successHandleAgent(action, value) {
    return Func.sagaSuccessMessage({
        action,
        message: `${i18n.t('notification.createSuccess')}`,
        description: `${i18n.t('item.agent.title')} "${value}"`
    })
}

function errorHandleAgent(errorActionType) {
    return Func.sagaErrorHandler(function* (e) {
        yield put({ type: errorActionType })
    }, 'siteInfo');
}

export function parseListRequestParamsCameo(params = {}) {
    const orderBy = params.OrderBy || params.orderBy || undefined;
    const orderByDesc = params.OrderByDesc !== undefined ? params.OrderByDesc : params.orderByDesc !== undefined ? params.orderByDesc : undefined;
    const startDate = params.startDate ? moment(params.startDate).toISOString() : undefined;
    const endDate = params.endDate ? moment(params.endDate).toISOString() : undefined;
    return {
        ...omit(params, ['OrderBy', 'OrderByDesc', 'totalCount', 'totalPage']),
        startDate, endDate, orderBy, orderByDesc,
        pageIndex: params.pageIndex && Number(params.pageIndex),
        pageSize: params.pageSize && Number(params.pageSize),
    }
}

export function* agentSaga() {
    yield all([
        fork(getAllListAgent),
        fork(getAgentListReports),
        fork(getListAgent),
        fork(getAgentDetail),
        fork(updateAgentDetail),
        fork(createAgentDetail),
        fork(deleteAgentDetail)
    ])
}
